export default function (content: Content[]) {
  return content
    .filter((module: any) => {
      return (
        module.image?.copyright ||
        module.copyright ||
        module.teaser?.some((teaser: Teaser) => teaser.image_copyright) ||
        module.slides?.some((slide: Slide) => slide.image_copyright)
      )
    })
    .flatMap((module: any) => {
      return (
        module.image?.copyright ||
        module.copyright ||
        module.teaser?.map((teaser: Teaser) => teaser.image_copyright) ||
        module.slides?.map((slide: Slide) => slide.image_copyright)
      )
    })
    .filter(Boolean) // remove "undefined" array elements
}
